import { IMapLibrePolygonItem } from "@ryde/controls";

import { AREA_POLYGON_COLORS } from "./area-polygons-map.constants";
import {
  IAreaPolygonItem,
  IBuildAreaPolygonItemsArgs,
} from "./area-polygons-map.models";

// Same area => same color, even when it owns several polygons.
export const getAreaPolygonColor = (index: number): string =>
  AREA_POLYGON_COLORS[index % AREA_POLYGON_COLORS.length];

export const hasPolygonFeatures = ({ polygon }: IAreaPolygonItem): boolean =>
  Boolean(polygon?.features?.length);

/** The areas the map actually draws: selected, holding a polygon, and not hidden from the legend. */
export const getVisibleAreaPolygons = (
  areas: IAreaPolygonItem[],
  hiddenIds?: ReadonlySet<number>,
): IAreaPolygonItem[] =>
  areas.filter(area => hasPolygonFeatures(area) && !hiddenIds?.has(area.id));

/**
 * Turns areas into the shared polygons layer's items.
 *
 * The area being reshaped is left out — the editor owns it — and, while that is happening, every other one
 * is faded to background context and stops taking clicks.
 */
export const buildAreaPolygonItems = ({
  areas,
  hiddenIds,
  editingId,
  isClickable,
}: IBuildAreaPolygonItemsArgs): IMapLibrePolygonItem[] => {
  const isEditing = typeof editingId === "number";

  return getVisibleAreaPolygons(areas, hiddenIds)
    .filter(({ id }) => id !== editingId)
    .map(({ id, name, color, polygon }) => ({
      id,
      color,
      polygon,
      isDimmed: isEditing,
      // Suppressed while dimmed, which is what dropped the Leaflet tooltip along with the hover styling.
      tooltip: isEditing || !isClickable ? undefined : `${name} (#${id})`,
    }));
};
